import React, { ReactElement, ReactNode, useRef, useState } from 'react';
import { Dropdown, InputGroup } from 'react-bootstrap';
import DropdownEntite, { PropsDeDropdownEntite } from '../../Common/DropdownEntite';
import { BaseEntite } from '../../../../../common/src/entities';
import { defaultTheme } from 'react-select';
import { BiSearch } from 'react-icons/all';
import { DropdownToggleProps } from 'react-bootstrap/DropdownToggle';

const { colors } = defaultTheme;

const DropdownIndicator = () => (
    <div style={{ color: colors.neutral20, height: 24, width: 32 }}>
        <BiSearch />
    </div>
);

const selectStyles = {
    control: (provided) => ({ ...provided, minWidth: '40vw', margin: 8 }),
    menu: () => ({ boxShadow: 'inset 0 1px 0 rgba(0, 0, 0, 0.1)' }),
    formGroup: () => ({ marginBottom: 0 }),
};

export type PropsDePopout<T extends BaseEntite> = PropsDeDropdownEntite<T> &
    Omit<DropdownToggleProps, 'onChange'> & {
        titre?: ReactNode;
        avecUnBouton?: boolean;
        appendedChildren?: ReactElement;
        affichageOption?: (entite: T) => ReactNode;
    };

export function PopoutEntite<T extends BaseEntite>(props: PropsDePopout<T>): ReactElement {
    const selectRef = useRef();
    const [show, setShow] = useState(false);
    const {
        titre,
        onChange,
        appendedChildren,
        entite,
        avecUnBouton,
        modalBody,
        modalSize,
        isCreatable,
        getOptionLabel,
        affichageOption,
        ...rest
    } = props;

    const dropDown: ReactElement = (
        <Dropdown
            onToggle={(isOpen) => {
                if (isOpen && selectRef.current) {
                    setTimeout(() => ((selectRef.current as unknown) as { focus: () => void }).focus(), 0);
                }
                setShow(isOpen);
            }}
            show={show}
        >
            <Dropdown.Toggle variant="outline-primary" {...rest}>
                {titre ?? 'Sélectionner'}
            </Dropdown.Toggle>
            <Dropdown.Menu className="p-0">
                <DropdownEntite
                    ref={selectRef}
                    onChange={(value, action) => {
                        setShow(false);
                        if (onChange) onChange(value, action);
                    }}
                    cacherTitre
                    components={{ DropdownIndicator, IndicatorSeparator: null }}
                    autoFocus={true}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={false}
                    hideSelectedOptions={false}
                    isClearable={false}
                    menuIsOpen
                    styles={selectStyles}
                    tabSelectsValue={false}
                    avecUnBouton={avecUnBouton}
                    entite={entite}
                    modalBody={modalBody}
                    modalSize={modalSize}
                    isCreatable={isCreatable}
                    getOptionLabel={getOptionLabel}
                    affichageOption={affichageOption}
                    {...rest}
                />
            </Dropdown.Menu>
        </Dropdown>
    );

    return appendedChildren ? (
        <InputGroup>
            {dropDown}
            <InputGroup.Append>{appendedChildren}</InputGroup.Append>
        </InputGroup>
    ) : (
        dropDown
    );
}
